import './ExperienceContainer.css'

const ExperienceContainer = ({ experience }) => (
  <div className='work-experience-container'>
    <h3>{experience.position}</h3>
    <h4>{experience.company}</h4>
    <p className='work-experience__duration'>{experience.duration}</p>
    <p className='work-experience__description'>{experience.description}</p>
  </div>
)

export default ExperienceContainer
